var _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_21_1",
    "data-name": "Componente 21 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 737,
    height: 333,
    viewBox: "0 0 737 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Roupas_e_Acess\\xF3rios_otaku_Geek",
    "data-name": "Roupas e Acess\\xF3rios otaku & Geek",
    transform: "translate(92 118)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    fontSize: 80,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600,
    letterSpacing: "0.07em",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ROUPAS E"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 97
  }, "ACESS\xD3RIOS"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 194
  }, "OTAKU &amp; GEEK"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Roupas_E_Acess\\xF3rios_otaku_Geek-2",
    "data-name": "Roupas E Acess\\xF3rios otaku & Geek",
    transform: "translate(0 78)",
    fontSize: 80,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600,
    letterSpacing: "0.07em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ROUPAS E"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 97
  }, "ACESS\xD3RIOS"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 194
  }, "OTAKU &amp; GEEK"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.c0d974785be2c17ec0616627d5d44054.svg";
export { ForwardRef as ReactComponent };